<template>
  <div>
    <allocation-mobile-view-tabs
      :tabs="tabs"
      v-model="tab"
      v-if="isMobile"
    ></allocation-mobile-view-tabs>
    <div class="allocation__view">
      <div
        class="allocation__view-left"
        v-if="!isMobile"
        style="padding-left: 0px"
      >
        <b-tabs v-model="tab" class="oa-tabs" pills card vertical :value="tab">
          <b-tab v-for="(item, i) in tabs" :key="i" :disabled="item.disabled">
            <template #title>
              <p class="mb-0">
                {{ item.name }}
              </p>
              <div class="font-size-10">
                {{ item.subtitle }}
              </div>
              <div class="font-size-10 mt-1">
                {{ item.created_on }}
              </div>
            </template>
          </b-tab>
        </b-tabs>
      </div>
      <div
        class="allocation__view-right p-0 oa-tabs-content"
        style="margin-left: 0px"
      >
        <generate-waiting-list
          :hospitals="hospitals"
          :item="item"
          waitlistType="LGW"
          :isLast="isLast"
          v-if="tabItem.status == 1"
        ></generate-waiting-list>
        <allocating-waiting-list
          :hospitals="hospitals"
          :item="item"
          :isLast="isLast"
          :status="tabItem.status"
          v-if="tabItem.status == 19"
        ></allocating-waiting-list>
        <update-my-waitlist
          :hospitals="hospitals"
          :status="tabItem.status"
          :history="history"
          :isLast="isLast"
          :item="item"
          v-if="tabItem.status == 19.1"
        ></update-my-waitlist>
        <generate-provisional-wait-list
          :hospitals="hospitals"
          :status="tabItem.status"
          :item="item"
          :isLast="isLast"
          v-if="tabItem.status == 21"
        ></generate-provisional-wait-list>
        <update-logistics-list
          :isLast="isLast"
          :item="item"
          v-if="tabItem.status == 7"
        ></update-logistics-list>
        <organ-infection-list
          :isLast="isLast"
          :item="item"
          v-if="tabItem.status == 25"
        >
        </organ-infection-list>
        <retrieval-list
          :item="item"
          v-if="tabItem.status == 26"
          :isLast="isLast"
        ></retrieval-list>
        <transplant-surgery
          :item="item"
          :isLast="isLast"
          v-if="tabItem.status == 28"
        ></transplant-surgery>
        <allocation-list
          :item="item"
          :isLast="isLast"
          v-if="tabItem.status == 18"
        ></allocation-list>
        <final-allocation-list
          :item="item"
          :isLast="isLast"
          v-if="tabItem.status == 43"
        ></final-allocation-list>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../../assets/js/common";
import AllocatingWaitingList from "./steps/AllocatingWaitingList.vue";
import GenerateProvisionalWaitList from "./steps/GenerateProvisionalWaitList.vue";
import GenerateWaitingList from "./steps/GenerateWaitingList.vue";
import OrganInfectionList from "./steps/OrganInfectionList.vue";
import RetrievalList from "./steps/RetrievalList.vue";
import TransplantSurgery from "./steps/TransplantSurgery.vue";
import UpdateLogisticsList from "./steps/UpdateLogisticsList.vue";
import UpdateMyWaitlist from "./steps/UpdateMyWaitlist.vue";
import AllocationMobileViewTabs from "../mobile/AllocationMobileViewTabs.vue";
import AllocationList from "./steps/AllocationList.vue";
import FinalAllocationList from "./steps/FinalAllocationList.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    history: {
      type: Array,
      default: () => [],
    },
    hospitals: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    GenerateWaitingList,
    UpdateMyWaitlist,
    AllocatingWaitingList,
    GenerateProvisionalWaitList,
    UpdateLogisticsList,
    OrganInfectionList,
    RetrievalList,
    TransplantSurgery,
    AllocationMobileViewTabs,
    AllocationList,
    FinalAllocationList,
  },
  data() {
    return {
      tab: null,
    };
  },
  computed: {
    isLast() {
      return this.tab == this.tabs.length - 1;
    },
    tabItem() {
      return this.tabs[this.tab] || {};
    },
    tabs() {
      let { allocation_status, organ_allocation_id } = this.item;
      let list = [
        {
          subtitle: "Wait List",
          disabled: allocation_status != 1,
          status: 1,
        },
        {
          subtitle: "Generated Wait List",
          status: 19,
        },
        {
          subtitle: "Update List",
          status: 19.1,
        },
        {
          subtitle: "Priority List",
          status: 21,
        },
        // {
        //   subtitle: "Logistics",
        //   status: 7,
        // },
        {
          subtitle: "Assessment Status",
          status: 25,
        },
        {
          subtitle: "Allocation",
          status: 18,
        },
        {
          subtitle: "Organ Retrieval",
          status: 26,
        },
        {
          subtitle: "Final Allocation",
          status: 43,
        },
        {
          subtitle: "Transplant Surgery",
          status: 28,
        },
      ];
      if (this.isAdmins) {
        list.splice(2, 1);
      }

      list = list.filter((item, i) => {
        let status = item.status;
        if (status == 19.1) status = 19;
        let history = this.history.find((doc) => {
          return (
            doc.status == status &&
            doc.organ_allocation_id == organ_allocation_id
          );
        });
        if (item.status == 1) return true;
        if (history != null) {
          list[i].created_on = formatDate(history.created_on);
        }
        return allocation_status == item.status || history != null;
      });
      return list.map((item, i) => {
        item.name = `Step ${i + 1}`;
        return item;
      });
    },
    fields() {
      let doc = {
        name: "Name",
        email_id: "Email ID / User ID",
        contact_name: "Role",
        phone_number_1: "Phone Number",
        status: "Status",
        action: "Action",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          key,
          label: doc[key],
          tdClass: key == "action" ? "width-100" : "",
        });
      });
      return list;
    },
  },
  mounted() {
    setTimeout(() => {
      this.tab = this.tabs.length - 1;
    }, 1000);
  },
};
</script>

<style lang="scss">
.oa-tabs {
  padding: 0px 24px !important;
  height: auto;
  &-content {
    margin-right: 12px;
    margin-left: 12px;
    flex: 1;
  }
  .col-auto {
    padding: 0px;
    overflow: hidden;
    background-color: transparent;
  }
  .tab-content {
    padding: 0px;
  }
  ul {
    background-color: transparent;
    padding: 0px;
  }
  ul:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(50% - 1px);
    border-left: 2px dashed #556ee6;
  }
  li {
    text-align: center;
    z-index: 100;
    margin-bottom: 50px;
    background-color: white;
    box-shadow: 0 0.5rem 1rem rgb(18 38 63 / 3%);
    border-radius: 0.25rem;
    white-space: nowrap;
    .nav-link {
      border-radius: 0.25rem;
    }
    &:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
